(() => {
  if (window.__tmpProductCardDirectAddReady) return;
  window.__tmpProductCardDirectAddReady = true;

  const cartAddUrl = () => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return `${root.replace(/\/?$/, '/')}cart/add.js`;
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.tmp-product-card-direct-add');
    if (!button || button.disabled) return;

    const form = button.closest('form[action*="/cart/add"]');
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = button.dataset.variantId || form.querySelector('input[name="id"]')?.value;
    if (!variantId) return;

    const wasDisabled = button.disabled;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('loading');

    try {
      const payload = new FormData(form);
      payload.set('id', variantId);
      payload.set('quantity', '1');

      const response = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: payload
      });
      const addedProduct = await response.json();

      if (!response.ok) {
        throw new Error(addedProduct?.description || addedProduct?.message || 'Could not add this product to the cart.');
      }

      document.dispatchEvent(new CustomEvent('product-ajax:added', {
        detail: { product: addedProduct }
      }));
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        detail: { open: true }
      }));
    } catch (error) {
      console.error('[TMP quick add]', error);
    } finally {
      button.classList.remove('loading');
      button.removeAttribute('aria-busy');
      button.disabled = wasDisabled;
    }
  }, true);
})();

/* TMP empty-cart bestsellers: show a few products from the manually sorted Bestselling Shades collection. */
(() => {
  if (window.__tmpEmptyCartBestsellersReady) return;
  window.__tmpEmptyCartBestsellersReady = true;

  let cachedProducts = null;
  let loadingPromise = null;

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#39;',
    '"': '&quot;'
  })[character]);

  const storeRoot = () => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/');
  };

  const formatMoney = (value) => {
    const amount = Number.parseFloat(value || 0);
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    const locale = document.documentElement.lang || 'en-NL';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
        maximumFractionDigits: Number.isInteger(amount) ? 0 : 2
      }).format(amount);
    } catch (_) {
      return `${currency === 'EUR' ? '€' : ''}${amount.toFixed(Number.isInteger(amount) ? 0 : 2)}`;
    }
  };

  const getProducts = async () => {
    if (cachedProducts) return cachedProducts;
    if (loadingPromise) return loadingPromise;

    loadingPromise = fetch(`${storeRoot()}collections/bestselling-shades/products.json?limit=4`, {
      headers: { Accept: 'application/json' }
    })
      .then((response) => {
        if (!response.ok) throw new Error('Could not load empty-cart bestsellers.');
        return response.json();
      })
      .then((data) => {
        cachedProducts = Array.isArray(data.products) ? data.products.slice(0, 4) : [];
        return cachedProducts;
      })
      .catch((error) => {
        console.error('[TMP empty cart bestsellers]', error);
        return [];
      })
      .finally(() => {
        loadingPromise = null;
      });

    return loadingPromise;
  };

  const productCard = (product) => {
    const image = product.images?.[0]?.src || product.image?.src || '';
    const variant = product.variants?.find((item) => item.available) || product.variants?.[0];
    const price = variant?.price || '0';
    const url = `${storeRoot()}products/${encodeURIComponent(product.handle)}`;
    const title = escapeHtml(product.title || '');
    const imageAlt = escapeHtml(product.images?.[0]?.alt || product.title || '');
    const variantId = variant?.id;
    const available = Boolean(variant?.available);
    const addLabel = escapeHtml(`Add ${product.title || 'product'} to cart`);

    return `
      <article class="tmp-empty-cart-bestseller">
        <div class="tmp-empty-cart-bestseller__media">
          <a class="tmp-empty-cart-bestseller__media-link" href="${url}" aria-label="${title}">
            ${image ? `<img src="${escapeHtml(image)}" alt="${imageAlt}" loading="lazy">` : ''}
          </a>
          ${variantId ? `
            <form method="post" action="${storeRoot()}cart/add" class="tmp-empty-cart-bestseller__form">
              <input type="hidden" name="id" value="${variantId}">
              <input type="hidden" name="quantity" value="1">
              <button
                type="submit"
                class="tmp-empty-cart-bestseller__atc tmp-product-card-direct-add"
                data-variant-id="${variantId}"
                aria-label="${addLabel}"
                ${available ? '' : 'disabled'}
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M19.575 6.75H4.425C4.24045 6.75087 4.06254 6.81891 3.92451 6.94141C3.78648 7.06391 3.69778 7.23249 3.675 7.41562L2.34375 19.4156C2.33191 19.5202 2.34221 19.6261 2.37396 19.7264C2.40572 19.8267 2.45823 19.9192 2.52808 19.9979C2.59794 20.0766 2.68357 20.1397 2.77941 20.1831C2.87525 20.2266 2.97916 20.2494 3.08438 20.25H20.9156C21.0209 20.2494 21.1248 20.2266 21.2206 20.1831C21.3164 20.1397 21.4021 20.0766 21.4719 19.9979C21.5418 19.9192 21.5943 19.8267 21.626 19.7264C21.6578 19.6261 21.6681 19.5202 21.6563 19.4156L20.325 7.41562C20.3022 7.23249 20.2135 7.06391 20.0755 6.94141C19.9375 6.81891 19.7596 6.75087 19.575 6.75V6.75Z"/>
                  <path d="M8.25 6.75C8.25 5.75544 8.64509 4.80161 9.34835 4.09835C10.0516 3.39509 11.0054 3 12 3C12.9946 3 13.9484 3.39509 14.6517 4.09835C15.3549 4.80161 15.75 5.75544 15.75 6.75"/>
                </svg>
              </button>
            </form>` : ''}
        </div>
        <a class="tmp-empty-cart-bestseller__meta" href="${url}">
          <span class="tmp-empty-cart-bestseller__title">${title}</span>
          <span class="tmp-empty-cart-bestseller__price">${escapeHtml(formatMoney(price))}</span>
        </a>
      </article>`;
  };

  const ensureStyles = () => {
    if (document.getElementById('TmpEmptyCartBestsellersStyles')) return;
    const style = document.createElement('style');
    style.id = 'TmpEmptyCartBestsellersStyles';
    style.textContent = `
      #CartDrawer .tmp-empty-cart-bestsellers{margin-top:8px;text-align:left}
      #CartDrawer .tmp-empty-cart-bestsellers__heading{margin:0 0 12px;font-family:"Arial Black",Arial,sans-serif;font-size:15px;font-weight:900;color:#010048;text-transform:uppercase}
      #CartDrawer .tmp-empty-cart-bestsellers__grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px}
      #CartDrawer .tmp-empty-cart-bestseller{display:block;min-width:0;color:inherit}
      #CartDrawer .tmp-empty-cart-bestseller__media{position:relative;width:100%;aspect-ratio:1/1;background:#f5f5f5;overflow:hidden}
      #CartDrawer .tmp-empty-cart-bestseller__media-link{position:absolute;inset:0;display:block;color:inherit;text-decoration:none}
      #CartDrawer .tmp-empty-cart-bestseller__media img{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;object-position:center}
      #CartDrawer .tmp-empty-cart-bestseller__form{position:absolute;top:9px;right:9px;z-index:3;margin:0}
      #CartDrawer .tmp-empty-cart-bestseller__atc{display:none}
      #CartDrawer .tmp-empty-cart-bestseller__meta{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:6px;align-items:end;padding-top:7px;color:inherit;text-decoration:none}
      #CartDrawer .tmp-empty-cart-bestseller__title{min-width:0;font-family:"Arial Black",Arial,sans-serif;font-size:10px;font-weight:900;line-height:1.05;text-transform:uppercase;overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2}
      #CartDrawer .tmp-empty-cart-bestseller__price{font-size:11px;font-weight:700;line-height:1;white-space:nowrap}
      @media (min-width:1024px){
        #CartDrawer .tmp-empty-cart-bestseller__atc{
          display:inline-flex!important;
          align-items:center!important;
          justify-content:center!important;
          width:24px!important;
          min-width:24px!important;
          max-width:24px!important;
          height:24px!important;
          min-height:24px!important;
          max-height:24px!important;
          padding:0!important;
          margin:0!important;
          border:1px solid #010048!important;
          border-radius:999px!important;
          background:#010048!important;
          color:#fff!important;
          box-shadow:none!important;
          cursor:pointer!important;
          line-height:1!important;
        }
        #CartDrawer .tmp-empty-cart-bestseller__atc svg{width:11px!important;height:11px!important;display:block!important}
        #CartDrawer .tmp-empty-cart-bestseller__atc:disabled{opacity:.45!important;cursor:not-allowed!important}
      }
    `;
    document.head.appendChild(style);
  };

  const mount = async () => {
    const emptyArea = document.querySelector('#CartDrawer [id^="CartDrawerEmpty-"]');
    if (!emptyArea || emptyArea.classList.contains('hidden')) return;
    if (emptyArea.querySelector('.tmp-empty-cart-bestsellers')) return;

    const target = emptyArea.querySelector('.cart-drawer__empty');
    if (!target) return;

    const products = await getProducts();
    if (!products.length || !document.documentElement.contains(target)) return;
    if (target.querySelector('.tmp-empty-cart-bestsellers')) return;

    ensureStyles();
    const wrapper = document.createElement('div');
    wrapper.className = 'tmp-empty-cart-bestsellers';
    wrapper.innerHTML = `
      <h3 class="tmp-empty-cart-bestsellers__heading">BESTSELLERS</h3>
      <div class="tmp-empty-cart-bestsellers__grid">${products.map(productCard).join('')}</div>
    `;
    target.appendChild(wrapper);
  };

  let scheduled = false;
  const scheduleMount = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      mount();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleMount, { once: true });
  } else {
    scheduleMount();
  }

  document.addEventListener('cart:refresh', scheduleMount);
  document.addEventListener('product-ajax:added', scheduleMount);
  new MutationObserver(scheduleMount).observe(document.documentElement, { childList: true, subtree: true });
})();

/* TMP desktop polish: persistent quick-add, round Trustpilot arrows, no account icon. */
(() => {
  const STYLE_ID = 'TmpDesktopPolish';
  if (document.getElementById(STYLE_ID)) return;

  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = `
    @media (min-width:1024px){
      body .product-card .product-card__image-wrapper .product-card__actions.product-card__main-actions,
      body .product-card .product-card__image-wrapper form.product-card__actions.product-card__main-actions{
        display:flex!important;
        opacity:1!important;
        visibility:visible!important;
        transform:none!important;
        pointer-events:auto!important;
      }
      body .product-card .product-card__image-wrapper .product-card__actions.product-card__main-actions .product-card__atc{
        display:inline-flex!important;
        opacity:1!important;
        visibility:visible!important;
        transform:none!important;
        pointer-events:auto!important;
      }
      body .product-card .product-card__image-wrapper .product-card__actions.product-card__main-actions .product-card__atc-icon{
        display:inline-flex!important;
        opacity:1!important;
        visibility:visible!important;
      }
      body .product-card .product-card__image-wrapper .product-card__actions.product-card__main-actions .product-card__atc-text{
        display:none!important;
      }
      body .header__icons--right .header__account{
        display:none!important;
      }
      body .tmp-trust__arrow{
        display:inline-flex!important;
        align-items:center!important;
        justify-content:center!important;
        flex:0 0 34px!important;
        width:34px!important;
        min-width:34px!important;
        max-width:34px!important;
        height:34px!important;
        min-height:34px!important;
        max-height:34px!important;
        padding:0!important;
        margin:0!important;
        aspect-ratio:1/1!important;
        box-sizing:border-box!important;
        border-radius:999px!important;
        line-height:1!important;
        white-space:nowrap!important;
        text-indent:0!important;
        overflow:hidden!important;
      }
    }
  `;
  document.head.appendChild(style);
})();

/* TMP product-page Trustpilot: reuse the exact homepage widget under related products on desktop. */
(() => {
  if (window.__tmpProductTrustFromHomeReady) return;
  window.__tmpProductTrustFromHomeReady = true;

  const isDesktop = () => window.matchMedia('(min-width: 1024px)').matches;

  const initTrustSlider = (wrapper) => {
    const root = wrapper?.querySelector('[data-tmp-trust]');
    if (!root || root.dataset.tmpProductTrustInitialized === 'true') return;
    root.dataset.tmpProductTrustInitialized = 'true';

    const rail = root.querySelector('[data-trust-rail]');
    const prev = root.querySelector('[data-trust-prev]');
    const next = root.querySelector('[data-trust-next]');
    if (!rail) return;

    const getStep = () => {
      const card = rail.querySelector('.tmp-trust__card');
      if (!card) return rail.clientWidth * .8;
      const styles = getComputedStyle(rail);
      return card.getBoundingClientRect().width + parseFloat(styles.gap || 0);
    };

    if (prev) prev.addEventListener('click', () => rail.scrollBy({ left: -getStep(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => rail.scrollBy({ left: getStep(), behavior: 'smooth' }));

    const autoplay = root.dataset.autoplay === 'true';
    const speed = Math.max(3, parseInt(root.dataset.autoplaySpeed || '5', 10)) * 1000;
    if (autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const timer = window.setInterval(() => {
        if (!document.documentElement.contains(root)) {
          window.clearInterval(timer);
          return;
        }
        const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
        rail.scrollTo({ left: atEnd ? 0 : rail.scrollLeft + getStep(), behavior: 'smooth' });
      }, speed);
    }
  };

  const mount = async () => {
    if (!isDesktop()) return;
    if (document.querySelector('[data-tmp-product-trust-from-home]')) return;

    const related = document.querySelector('.section--related-products');
    if (!related) return;
    const relatedSection = related.closest('.shopify-section') || related;

    try {
      const sectionUrl = new URL('/', window.location.origin);
      sectionUrl.searchParams.set('section_id', 'trust_slider_Gtp93z');
      const previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (previewThemeId) sectionUrl.searchParams.set('preview_theme_id', previewThemeId);

      const response = await fetch(sectionUrl.toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      });
      if (!response.ok) throw new Error('Could not load homepage Trustpilot section.');

      const html = await response.text();
      const holder = document.createElement('div');
      holder.innerHTML = html.trim();
      const source = holder.querySelector('.tmp-trust-section, [id^="shopify-section-trust_slider_Gtp93z"]') || holder.firstElementChild;
      if (!source || !source.querySelector('[data-tmp-trust]')) throw new Error('Homepage Trustpilot section was not found.');

      source.querySelectorAll('script').forEach((script) => script.remove());
      source.setAttribute('data-tmp-product-trust-from-home', 'true');
      relatedSection.insertAdjacentElement('afterend', source);
      initTrustSlider(source);
    } catch (error) {
      console.error('[TMP homepage Trustpilot copy]', error);
    }
  };

  const scheduleMount = () => requestAnimationFrame(mount);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleMount, { once: true });
  } else {
    scheduleMount();
  }

  new MutationObserver(() => {
    if (!document.querySelector('[data-tmp-product-trust-from-home]')) scheduleMount();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
